import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { useState } from "react";

export const ScheduleGrid = () => {
  const [date, setDate] = useState<Date | undefined>(new Date());

  return (
    <Card className="p-4">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Calendar
            mode="single"
            selected={date}
            onSelect={setDate}
            className="rounded-md border"
          />
        </div>
        <div className="space-y-4">
          <h3 className="text-lg font-semibold">Available Time Slots</h3>
          <div className="space-y-2">
            {/* Time slots will be listed here */}
          </div>
          <Button className="w-full">Schedule Meeting</Button>
        </div>
      </div>
    </Card>
  );
};
